export default __webpack_public_path__ + "static/media/ac_vir.1c078e70.bmp";